import Image, { ImageProps } from 'next/image'
import React, { FC } from 'react'

import * as SC from './styled'

export type NavPushProps = {
  className?: string
  color?: string
  imageProps?: ImageProps
  firstHighlightText?: string
  secondHighlightText?: string
  ctaHref?: string
  buttons?: JSX.Element
}

const NavPush: FC<NavPushProps> = (props) => {
  const {
    className,
    color,
    imageProps,
    firstHighlightText,
    secondHighlightText,
    buttons,
  } = props

  return (
    <SC.Container className={className}>
      <SC.Foreground>
        <SC.Highlights>
          {firstHighlightText && (
            <SC.FirstHighlight
              text={firstHighlightText}
              backgroundColor={color}
            />
          )}
          {secondHighlightText && (
            <SC.SecondHighlight text={secondHighlightText} />
          )}
        </SC.Highlights>
        {buttons && <SC.Buttons>{buttons}</SC.Buttons>}
      </SC.Foreground>
      <SC.Background aria-hidden={true} backgroundColor={color}>
        {imageProps && <Image {...imageProps} />}
      </SC.Background>
    </SC.Container>
  )
}

export default NavPush
